module.exports = __webpack_public_path__ + "img/emailVerified.54496863.svg";